export const API_NAME = 'mail';
export const API_VERSION = 'v1';
export const API_BASE_URL = `${API_NAME}/${API_VERSION}`;

export const DEFAULT_ORDER: 'ASC' | 'DESC' = 'ASC';
export const DEFAULT_ROWS = 20;
